export const fetchChatMessages = ({ wsApi, visitorToken }) =>
  fetch(
    `${wsApi}/chat-messages?visitor_token=${encodeURI(visitorToken)}`,
    { headers: { Accept: 'application/json' } }
  ).then((res) => res.json());
